import { useEffect, useState } from 'react';

/**
 * Get the current review id by scraping the URL
 *
 * TODO: find a better way of doing this, along with getStudyId
 */
export const useReviewId = () => {
  const [reviewId, setReviewId] = useState<string | null>(null);

  useEffect(() => {
    const tokens = window.location.href.split('/');
    const index = tokens.indexOf('reviews');

    if (index >= 0 && index < tokens.length - 1) {
      return setReviewId(tokens[index + 1]);
    }
  }, []);

  return reviewId;
};
